import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import ActionsWithReviews from 'molecules/ActionsWithReviews/ActionsWithReviews';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const HeroTextBlock = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl']}
  >
    <Stack
      direction='column'
      columns={7}
      columnsXl={9}
      columnsLg={11}
      columnsMd={12}
      gap='spacing-6xl'
      gapSm='spacing-4xl'
    >
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: '2xl',
          text: 'Connection is the feature that changes everything',
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          text: 'Mighty powers more $1M communities. Why? Because everything is designed to bring your members closer together.',
          color: 'text-tertiary',
        }}
      />
      <ActionsWithReviews buttonText='Try Mighty Free' />
    </Stack>
  </Grid>
);

export default HeroTextBlock;
